import React, { useState, useRef, useEffect, useMemo } from "react"
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu, } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from 'primereact/fileupload';
import { InputText } from "primereact/inputtext";
import axios from "axios";
import { getCookie } from "../../helpers/cookie"
import { Toast } from "primereact/toast"
const MoreACcontacts = ({value}) => {
const token = getCookie('access_token');
    const [changeStatusAction, setChangeStatusAction] = useState(false)
    const toast = useRef(null); 
    const [selectedLinkJob, setSelectedLinkJob] = useState(null)
     const handleProtectedAction = (action) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      toast.current?.show({
        severity: "error",
        summary: "Validation",
        detail: "Please select at least one candidate",
      });
      return;
    }
    action();
  };
const fileUploadRef = useRef(null);
const handleCloseDialog = () => {
    setIsAttachDocumentVisible(false);
    setUploadedFiles([]);
    setSelectedDocumentType(null);
    setDocSubject("");
  }
  const moreoptions = [
    {
      name: "Attachments",
      onClick: () => handleProtectedAction(() => setIsAttachDocumentVisible(true)),
    },
    {
      name: "Change Status",
      onClick: () => handleProtectedAction(() => setChangeStatusAction(true)),
    },
    // {
    //   name: "Delete",
    //   onClick: () => handleProtectedAction(() => {
    //     // your delete logic here
    //   }),
    // },
  ];

    const [isAttachDocumentVisible, setIsAttachDocumentVisible] = useState(false);

    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [documentTypes,setdocumenttypes]= useState('') 
    // const documentTypes = [
    //     { name: "Hiring Manager Profiles", code: "INV" },
    //     { name: " Job Requisition Forms", code: "CTR" },
    //     { name: "Communication Records", code: "PRP" },
    //     { name: "Interview Feedback & Evaluation Reports", code: "RPT" },
    //     { name: "Service Agreements / Contracts", code: "AGR" },
    //     { name: "Meeting Notes & Interview Schedules", code: "AGR" },
    // ];
    const getDoctType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_document_type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status===200) {
                    const options = response.data.results.results.map((category) => ({
            name: category.value
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase()),
            code: category.id,
            }));
            setdocumenttypes(options);
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(()=>
    {
        getDoctType()
    },[])
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const onUpload = (event) => {
        // Store the uploaded files in state
        setUploadedFiles((prevFiles) => [...prevFiles, ...event.files]);
    };

    const [docSubject, setDocSubject] = useState("");
    const handleFileUploadChange = (e) => {
    const f = e.target.files && e.target.files[0]
    setUploadedFiles(f)
  }
    const handleSubnit = async () => {
        try {
            const formData = new FormData()
            formData.append('type', selectedDocumentType?.code)
            formData.append('description', docSubject)
            if (uploadedFiles instanceof File) {
                formData.append('uploaded_files', uploadedFiles);
            }
            else if (Array.isArray(uploadedFiles)) {
                uploadedFiles.forEach((file, idx) => {
                    formData.append('uploaded_files', file); 
                });
            }
            const response = await axios.post(`${process.env.REACT_APP_Company_Contact}/company/contacts/${value}/documents/`,formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 201) {
                 toast.current && toast.current.show({ severity: 'success', summary: 'Added', detail: 'Document Added Successfully' })
                 setIsAttachDocumentVisible(false)
                 setUploadedFiles(null)
                 setDocSubject("")
                 setSelectedDocumentType('')
            }
        } catch (err) {
            console.log(err);

        }
    }
    return (
        <React.Fragment>
         <Toast ref={toast} />
            <CascadeSelect
                value={selectedLinkJob}
                onChange={(e) => {
                    if (e.value && e.value.onClick) {
                        e.value.onClick();
                    }
                }}
                options={moreoptions}
                optionLabel="name"
                optionGroupLabel="name"
                optionGroupChildren={["jobs"]}
                placeholder="More"
                className="me-1"
            />


            <Dialog
                header="Change Status"
                visible={changeStatusAction}
                onHide={() => setChangeStatusAction(false)}
                style={{ width: '30vw' }}
                className="changestatus-popup"
            >
                {/* Search Bar */}
                <Row className="mt-2 align-items-center">
                    <Col xl={2}>
                        <label className="block mb-2"                                  >
                            Status
                        </label>
                    </Col>
                    <Col xl={10}>
                        <div className="card flex justify-content-center mb-0 border-0">
                            <select
                                className='form-select profileDetailsInput' id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                            >
                                <option value=' '>Active</option>
                                <option value='InActive'>InActive</option>
                                <option value='InActive'>DND (Do Not Disturb)</option>
                                <option value='InActive'>Blacklisted</option>

                            </select>
                        </div>
                    </Col>
                </Row>

                <div className="d-flex justify-content-end  mt-4">
                    <button type="button" class="btn btn-primary btn-main" onClick={() => setChangeStatusAction(false)}>Submit</button>
                </div>
            </Dialog>
            <Dialog
                header="Attachments"
                visible={isAttachDocumentVisible}
                onHide={handleCloseDialog}
                style={{ width: '45vw' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <Row className="align-items-center">
                    <Col xl={6}>
                        <div className="card flex justify-content-center mb-0 border-0">
                            <label className="block mb-2">
                                Document Type
                            </label>
                            <Dropdown
                                value={selectedDocumentType}
                                onChange={(e) => setSelectedDocumentType(e.value)}
                                options={documentTypes}
                                optionLabel="name"
                                placeholder="Select a Document Type"
                                className="w-full bgclr"
                            />
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="p-field mt-2">
                            <label htmlFor="docSubject" className="block">Document Subject</label>
                            <InputText
                                id="docSubject"
                                value={docSubject}
                                onChange={(e) => setDocSubject(e.target.value)}
                                placeholder="Enter Document Subject"
                                className="p-inputtext-sm w-full"
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="card flex justify-content-center mb-0 border-0 mt-2">
                            <label className="block mb-2">
                                Attach Documents
                            </label>
                            <FileUpload
                                ref={fileUploadRef}
                                name="files[]"
                                accept="image/jpg,image/jpeg,image/png,application/pdf"
                                maxFileSize={1000000}
                                multiple
                                customUpload
                                auto
                                uploadHandler={(e) => {
                                    setUploadedFiles(e.files)
                                }}
                                onClear={() => {
                                    console.log("Files cleared")
                                    setUploadedFiles([])
                                }}
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <button
                            className="btn btn-primary btn-main mt-2"
                            onClick={handleSubnit}
                        >
                            Submit
                        </button>
                    </Col>
                </Row>
            </Dialog>

        </React.Fragment>
    );
};



export default MoreACcontacts;